const Headline = ({children}) => {
  return <h1 className="h5 mb-4">{children}</h1>
}

export default Headline